import { Typography } from "@mui/material";
import FragmentFullContent from "./FragmentFullContent";
import React from "react";

export interface FragmentEmptyProps {
  message?: React.ReactNode;
}
const FragmentEmpty = ({ message }: FragmentEmptyProps) => {
  return <FragmentFullContent>
            <Typography variant="body2" component="div">
                {message || "Nenhum item encontrado"}
            </Typography>
        </FragmentFullContent>;
};

export default FragmentEmpty;